// Card Cliente: toggle esistente/nuovo, selezione cliente esistente e vista sola lettura
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import {
    Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../ui/select';
import { User, MapPin } from '@phosphor-icons/react';
import { NewCustomerForm } from './NewCustomerForm';

export const CustomerSelectionCard = ({
    quote, isEditable, customers, getCustomerName,
    customerMode, setCustomerMode,
    newCustomerData, setNewCustomerData, savingCustomer, onSaveNewCustomer,
    onUpdateQuote,
}) => (
    <Card>
        <CardHeader>
            <CardTitle className="flex items-center gap-2">
                <User className="w-5 h-5" />
                Cliente
            </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
            {isEditable && (
                <>
                    {/* Toggle cliente esistente / nuovo */}
                    <div className="flex gap-2 p-1 bg-zinc-100 rounded-lg">
                        <button
                            className={`flex-1 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                                customerMode === 'existing'
                                    ? 'bg-white shadow-sm text-zinc-900'
                                    : 'text-zinc-600 hover:text-zinc-900'
                            }`}
                            onClick={() => setCustomerMode('existing')}
                        >
                            Cliente Esistente
                        </button>
                        <button
                            className={`flex-1 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                                customerMode === 'new'
                                    ? 'bg-white shadow-sm text-zinc-900'
                                    : 'text-zinc-600 hover:text-zinc-900'
                            }`}
                            onClick={() => setCustomerMode('new')}
                        >
                            Nuovo Cliente
                        </button>
                    </div>

                    {customerMode === 'existing' ? (
                        /* Selezione cliente esistente */
                        <div className="space-y-4">
                            <Select
                                value={quote.customer_id || "none"}
                                onValueChange={(v) => onUpdateQuote({ customer_id: v === "none" ? null : v })}
                            >
                                <SelectTrigger data-testid="customer-select">
                                    <SelectValue placeholder="Seleziona cliente..." />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectItem value="none">Nessun cliente</SelectItem>
                                    {customers.map((c) => (
                                        <SelectItem key={c.id} value={c.id}>
                                            {getCustomerName(c)} {c.email && `(${c.email})`}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>

                            {quote.customer && (
                                <div className="space-y-2 pt-2 border-t">
                                    <div className="flex items-start gap-2">
                                        <User className="w-4 h-4 text-zinc-400 mt-1" />
                                        <div>
                                            <p className="font-medium">{getCustomerName(quote.customer)}</p>
                                            <p className="text-sm text-zinc-500">{quote.customer.email}</p>
                                            <p className="text-sm text-zinc-500">{quote.customer.telefono}</p>
                                        </div>
                                    </div>
                                    {quote.customer.indirizzo && (
                                        <div className="flex items-start gap-2">
                                            <MapPin className="w-4 h-4 text-zinc-400 mt-1" />
                                            <div>
                                                <p className="text-sm">{quote.customer.indirizzo}</p>
                                                <p className="text-sm text-zinc-500">
                                                    {quote.customer.cap} {quote.customer.citta} ({quote.customer.provincia})
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    ) : (
                        <NewCustomerForm
                            newCustomerData={newCustomerData}
                            setNewCustomerData={setNewCustomerData}
                            savingCustomer={savingCustomer}
                            onSaveNewCustomer={onSaveNewCustomer}
                        />
                    )}
                </>
            )}

            {!isEditable && (
                <div className="space-y-2">
                    <p className="font-medium">{quote.customer_name || 'Non specificato'}</p>
                    {quote.customer && (
                        <>
                            <p className="text-sm text-zinc-500">{quote.customer.email}</p>
                            <p className="text-sm text-zinc-500">{quote.customer.telefono}</p>
                            {quote.customer.indirizzo && (
                                <p className="text-sm text-zinc-500">
                                    {quote.customer.indirizzo}, {quote.customer.cap} {quote.customer.citta}
                                </p>
                            )}
                        </>
                    )}
                </div>
            )}
        </CardContent>
    </Card>
);
